import { useTranslation } from 'react-i18next';
import { Avatar } from '../../avatar';
import { Flex } from '../../flex';
import { Icon } from '../../icons';
import { Text } from '../../typography';
import styles from './new-message-item.module.css';

const NewMessageItem = () => {
  const { t } = useTranslation(['translationReactComponents']);

  return (
    <Flex align="center" className={styles.root} gap="xs">
      <Avatar
        className={styles.avatar}
        fallbackPhoto={false}
        icon={<Icon icon="user-1-line" size="small" />}
        size="large"
      />
      <Text type="title" weight="medium">
        {t('New message')}
      </Text>
    </Flex>
  );
};

export default NewMessageItem;
